import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import { BASE_URL, FETCH_UPDATE_COMMISSION_LOG, M_POST } from '@/utils/api';

@Module({ name: 'updatecommissionlog' })
export default class UpdateCommissionLog extends VuexModule {
  @Action({ rawError: true })
  async FetchCommissionLog(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + FETCH_UPDATE_COMMISSION_LOG,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch update commission log failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch update commission log failed');
    }
  }
}
